module.exports = __webpack_public_path__ + "img/small_flug_active.57d8fa8c.svg";